import React from 'react';
import { FiAlertTriangle, FiRefreshCw, FiArrowLeft } from 'react-icons/fi';

export class CRMErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('CRITICAL: CRM Module Error Intercepted:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[500px] h-full flex items-center justify-center p-8 bg-[#f8f9fb] text-[#161a2e]">
          <div className="bg-white max-w-2xl w-full p-8 border border-rose-200 shadow-xl rounded-2xl animate-in">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 bg-rose-50 border border-rose-200 rounded-xl flex items-center justify-center text-rose-600 shrink-0">
                <FiAlertTriangle className="w-6 h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-[#161a2e] tracking-tight">CRM Module Error Intercepted</h2>
                <p className="text-xs text-rose-600 font-medium">Finance platform & session remain completely isolated and intact.</p>
              </div>
            </div>

            <div className="bg-[#f8f9fb] border border-[#e6e8ee] rounded-xl p-4 mb-6">
              <p className="text-xs font-mono text-[#161a2e] break-words">
                {this.state.error?.toString() || 'Unknown runtime error'}
              </p>
              {this.state.errorInfo?.componentStack && (
                <details className="mt-3">
                  <summary className="text-[11px] text-[#7b8195] hover:text-[#161a2e] cursor-pointer select-none">
                    View Component Stack Trace
                  </summary>
                  <pre className="text-[10px] font-mono text-[#575e74] mt-2 p-2 bg-white rounded border border-[#e6e8ee] overflow-x-auto max-h-40">
                    {this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
            </div>

            <div className="flex items-center justify-between gap-4">
              {this.props.onSwitchToFinance && (
                <button
                  type="button"
                  onClick={this.props.onSwitchToFinance}
                  className="flex items-center gap-2 px-4 py-2.5 bg-[#f1f2f6] hover:bg-[#e6e8ee] text-[#161a2e] text-xs font-semibold rounded-xl border border-[#d3d6df] transition-all cursor-pointer shadow-sm"
                >
                  <FiArrowLeft className="w-4 h-4" /> Return to Finance Tab
                </button>
              )}
              <button
                type="button"
                onClick={this.handleReset}
                className="flex items-center gap-2 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-semibold rounded-xl shadow-sm transition-all ml-auto cursor-pointer"
              >
                <FiRefreshCw className="w-4 h-4" /> Try Again / Reload CRM
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default CRMErrorBoundary;
